export const InventoryFormStorageMode = Object.freeze({
	Offline: 0,
	Online: 1,
});
